import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailBlock from './DetailBlock';
export default {
  name: 'detail-promotion',
  components: {
    DetailBlock: DetailBlock
  },
  props: {
    peforamcne: {
      type: Object,
      value: null
    },
    discountList: {
      type: Array,
      value: []
    },
    preferenceList: {
      type: Array,
      value: []
    },
    setTicketList: {
      type: Array,
      value: []
    },
    projectGiftVO: {
      type: Array,
      value: []
    },
    supportWenhui: {
      type: Boolean
    },
    wenhuiActivityUrl: {
      type: String,
      value: ''
    },
    businessBatchList: {
      type: Array,
      value: []
    },
    // 优惠场次数量
    promotionalShowNum: {
      type: Number,
      value: 0
    }
  },
  computed: {
    getBatchList: function getBatchList() {
      var arr = this.businessBatchList.length > 5 ? this.businessBatchList.slice(0, 5) : this.businessBatchList;
      return arr;
    },
    getDiscountNum: function getDiscountNum() {
      var discountNum = this.discountList && this.discountList.length || 0;
      return discountNum;
    },
    getPreferenceNum: function getPreferenceNum() {
      var preferenceNum = this.preferenceList && this.preferenceList.length || 0;
      return preferenceNum;
    },
    getTicketListNum: function getTicketListNum() {
      var ticketNum = this.setTicketList && this.setTicketList.length || 0;
      return ticketNum;
    },
    getGiftVONum: function getGiftVONum() {
      var giftNum = this.projectGiftVO && this.projectGiftVO.length || 0;
      return giftNum;
    },
    getCouponNum: function getCouponNum() {
      var couponNum = this.businessBatchList && this.businessBatchList.length || 0;
      return couponNum;
    }
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_tm9bjlny'
    });
  },
  methods: {
    click: function click() {
      this.$emit('togglePromition');
    },
    wenhuiClick: function wenhuiClick(url) {
      this.go(url);
      // 组织弹层中的事件
      event.stopPropagation();
    }
  }
};